function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as React from 'react';
import { EventManager } from '@mui/x-internals/EventManager';
import { Store } from "../../utils/Store.js";
import { useGridApiMethod } from "../utils/useGridApiMethod.js";
import { GridSignature } from "../utils/useGridApiEventHandler.js";
var SYMBOL_API_PRIVATE = Symbol('mui.api_private');
var isSyntheticEvent = function(event) {
    return event.isPropagationStopped !== undefined;
};
export function unwrapPrivateAPI(publicApi) {
    return publicApi[SYMBOL_API_PRIVATE];
}
var globalId = 0;
function createPrivateAPI(publicApiRef) {
    var _publicApiRef_current;
    var existingPrivateApi = (_publicApiRef_current = publicApiRef.current) === null || _publicApiRef_current === void 0 ? void 0 : _publicApiRef_current[SYMBOL_API_PRIVATE];
    if (existingPrivateApi) {
        return existingPrivateApi;
    }
    var state = {};
    var privateApi = {
        state: state,
        store: Store.create(state),
        instanceId: {
            id: globalId
        }
    };
    globalId += 1;
    privateApi.getPublicApi = function() {
        return publicApiRef.current;
    };
    privateApi.register = function(visibility, methods) {
        Object.keys(methods).forEach(function(methodName) {
            var method = methods[methodName];
            var currentPrivateMethod = privateApi[methodName];
            if ((currentPrivateMethod === null || currentPrivateMethod === void 0 ? void 0 : currentPrivateMethod.spying) === true) {
                currentPrivateMethod.target = method;
            } else {
                privateApi[methodName] = method;
            }
            if (visibility === 'public') {
                var publicApi = publicApiRef.current;
                var currentPublicMethod = publicApi[methodName];
                if ((currentPublicMethod === null || currentPublicMethod === void 0 ? void 0 : currentPublicMethod.spying) === true) {
                    currentPublicMethod.target = method;
                } else {
                    publicApi[methodName] = method;
                }
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new EventManager()
    });
    return privateApi;
}
function createPublicAPI(privateApiRef) {
    var publicApi = _define_property({
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        }
    }, SYMBOL_API_PRIVATE, privateApiRef.current);
    return publicApi;
}
export function useGridApiInitialization(inputApiRef, props) {
    var _inputApiRef_current;
    var publicApiRef = React.useRef(null);
    var privateApiRef = React.useRef(null);
    if (!privateApiRef.current) {
        privateApiRef.current = createPrivateAPI(publicApiRef);
    }
    if (!publicApiRef.current) {
        publicApiRef.current = createPublicAPI(privateApiRef);
    }
    var publishEvent = React.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args = _sliced_to_array(args, 3), name = _args[0], params = _args[1], tmp = _args[2], event = tmp === void 0 ? {} : tmp;
        event.defaultMuiPrevented = false;
        if (isSyntheticEvent(event) && event.isPropagationStopped()) {
            return;
        }
        var details = props.signature === GridSignature.DataGridPro || props.signature === GridSignature.DataGridPremium ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    var subscribeEvent = React.useCallback(function(event, handler, options) {
        privateApiRef.current.eventManager.on(event, handler, options);
        var api = privateApiRef.current;
        return function() {
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    useGridApiMethod(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    if (inputApiRef && !((_inputApiRef_current = inputApiRef.current) === null || _inputApiRef_current === void 0 ? void 0 : _inputApiRef_current.state)) {
        inputApiRef.current = publicApiRef.current;
    }
    React.useImperativeHandle(inputApiRef, function() {
        return publicApiRef.current;
    }, [
        publicApiRef
    ]);
    React.useEffect(function() {
        var api = privateApiRef.current;
        return function() {
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}
